import * as tslib_1 from "tslib";
// --
import { Location, PlatformLocation } from "@angular/common";
import { OnInit, Renderer2 } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
// Servicios de la API GALAVAIL
import { GalavailServiceEcommer } from "clientwsGalavail";
// Servicios NGFlow
import { NgWebflowService } from "ngweflow";
import { DeviceDetectorService } from "ngx-device-detector";
import { TipoPaqueteEcommerceEnum } from "src/app/enums/tipo-paquete-ecommerce.enum";
import { CompanyService } from "src/app/services/company/company.service";
import { PromoService } from "src/app/services/promo.service";
import { environment } from "src/environments/environment";
import { FormModel } from "../../models/form.model";
// Servicio de Store Local data inquire
import { StoreInquireService } from "../../services/store-inquire.service";
// Servicio para setear titulo de pagina
import { TitlePagesService } from "../../services/title-pages.service";
import { ShareModalComponent } from "../results/share-modal/share-modal.component";
import { RoyalRequestService } from "./royal-request.service";
import * as Cookies from "es-cookie";
import { ReservationClass } from "src/app/classes/reservation.class";
import { WebFlowAction } from "src/app/core/enums/web-flow-actions.enum";
import { PromoTypeCode } from "src/app/enums/promo-type-code.enum";
import { UtilDate } from "src/app/shared/util/util-date";
import { SearchCountryField, CountryISO, TooltipLabel } from 'ngx-intl-tel-input-angular7';
import { isNullOrUndefined } from 'util';
var FormComponent = /** @class */ (function () {
    function FormComponent(activatedRoute, router, title, galavailServiceEcommer, ngWebflowService, storeLocalInquireService, document, renderer2, location, platformLocation, dialog, companyService, royalRequestService, promoService, deviceDetectorService, utilDate) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.title = title;
        this.galavailServiceEcommer = galavailServiceEcommer;
        this.ngWebflowService = ngWebflowService;
        this.storeLocalInquireService = storeLocalInquireService;
        this.document = document;
        this.renderer2 = renderer2;
        this.location = location;
        this.platformLocation = platformLocation;
        this.dialog = dialog;
        this.companyService = companyService;
        this.royalRequestService = royalRequestService;
        this.promoService = promoService;
        this.deviceDetectorService = deviceDetectorService;
        this.utilDate = utilDate;
        this.optionA = TipoPaqueteEcommerceEnum.TYPE_A;
        this.reservationClass = new ReservationClass();
        this.todayDate = new Date().getFullYear();
        this.urlElementsArray = [];
        this.isCharterOnly = false;
        this.dateToday = new Date();
        this.companyLogo = environment.appResource.companyLogos;
        this.logoCruise = environment.appResource.logoCruise;
        this.listCountries = [];
        this.URLMonth = '';
        this.URLYear = '';
        this.URLDateRange = '';
        this.CODEPROCESS = "RG.NP.AV";
        this.deviceInfo = null;
        this.disableChildren = false;
        this.geoIp = "";
        this.isOnHold = false;
        this.monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        this.WELCOME_TEXT = "Inquire now about your perfect Cruise aboard the ";
        this.PROMO_RAC = PromoTypeCode.PROMO_RAC;
        this.SearchCountryField = SearchCountryField;
        this.TooltipLabel = TooltipLabel;
        this.CountryISO = CountryISO;
        this.isLoading = true;
        this.listCountries = royalRequestService.getCountries();
        this.howFindUsList = royalRequestService.getHowFindUsList();
        this.getDataofUrl();
    }
    FormComponent.prototype.renderTextPromotion = function (rowDate, setWithCharter) {
        var textPromo;
        var arrayTextPromo;
        if (rowDate.charterOnly || this.isCharterOnly || setWithCharter) {
            var diferenciaCharter = void 0;
            diferenciaCharter = rowDate.charterPrice - rowDate.charterPricePromo;
            if (diferenciaCharter == 0) {
                textPromo = "";
            }
            else {
                if (this.companyService.getCode() === 'MQ==') {
                    if ((this.type === '0') || (this.type === '1')) {
                        textPromo = 'USD$' + diferenciaCharter + ' OFF';
                    }
                }
                else {
                    arrayTextPromo = rowDate.charterPromotionLabel.split(" - ");
                    textPromo = arrayTextPromo[0].trim();
                }
            }
        }
        else {
            if (rowDate.promotionType === this.PROMO_RAC && rowDate.promotionLabel === "") {
                textPromo = 'none';
            }
            else {
                arrayTextPromo = rowDate.promotionLabel.split(" - ");
                textPromo = arrayTextPromo[0].trim();
            }
        }
        return textPromo === "0" ? "" : textPromo;
    };
    FormComponent.prototype.initForm = function () {
        this.registerForm = new FormModel(this.empresa.toString(), this.barco, this.promocion, this.fechaArrivo, this.fechaSalida, this.dias, this.duracion, this.opcDuracion, 
        // Number(this.adultos),
        Number(this.storeLocalInquireService.getPaseengers()), 0, "", false, false, false, false, "", "", "", "", undefined, "", "", "", "", false, [], "", "");
    };
    FormComponent.prototype.changeTitlePage = function () {
        this.title.changeTitlePage(this.storeLocalInquireService.getBoat(), "inquire");
    };
    FormComponent.prototype.isCharterOnlyOrSearchedCharter = function (type, c) {
        if (type === '0') {
            return true;
        }
        else {
            return c.charterOnly || this.isCharterOnly;
        }
    };
    FormComponent.prototype.getPromotion = function (charterOnly, promotionLabel, charterPromotionLabel) {
        if (this.type === '0') {
            return this.renderTextPromotion(this.cruise.availability[0], true);
        }
        else {
            return this.renderTextPromotion(this.cruise.availability[0]);
        }
    };
    FormComponent.prototype.getTextTempContPromotion = function (type) {
        if (type === '0') {
            return 'Charter';
        }
        else {
            return this.isCharterOnlyOrSearchedCharter(this.type, this.cruise.availability[0]) ? 'Charter' : 'none';
        }
    };
    FormComponent.prototype.getCharterPrice = function (type) {
        if (type === '0') {
            return this.cruise.availability[0].charterPrice;
        }
        else {
            return this.isCharterOnlyOrSearchedCharter(this.type, this.cruise.availability[0]) ? this.cruise.availability[0].charterPrice : this.cruise.availability[0].rackPrice;
        }
    };
    FormComponent.prototype.getCharterPricePromo = function (type) {
        if (type === '0') {
            return this.cruise.availability[0].charterPricePromo;
        }
        else {
            return this.isCharterOnlyOrSearchedCharter(this.type, this.cruise.availability[0]) ? this.cruise.availability[0].charterPricePromo : this.cruise.availability[0].promotionPrice;
        }
    };
    FormComponent.prototype.getDataofUrl = function () {
        var _this = this;
        this.subscription = this.activatedRoute.params.subscribe(function (params) {
            _this.type = params["type"];
            _this.empresa = params["company"];
            _this.keyCompany = params["code"];
            _this.codeAvailability = params["codeAvailability"];
            _this.isOnHold = params["inquire"] === "inquire" ? false : true;
            _this.urlShare = "";
            _this.messageCopied = false;
        });
        this.showButtonSend = true;
        this.showSending = false;
    };
    FormComponent.prototype.getListObjectToForm = function () {
        return this.dataCompany.listInterest.map(function (item) {
            return { description: item, status: false };
        });
    };
    FormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.generateKeyCompany();
        this.royalRequestService.getGeoIpDirection().subscribe(function (ip) {
            _this.geoIp = ip;
        });
        this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
        this.galavailServiceEcommer.findCompany(this.requestCompany).subscribe(function (response) {
            _this.dataCompany = response;
            _this.companyService.setCompany(response);
            // console.log('EMPRESA', this.dataCompany);
            _this.mailTo = "mailto:" + _this.dataCompany.infoEmail;
            _this.cargarValoresPLantilla();
            _this.requestFindAvailabilityByCode = {
                code: Number(_this.codeAvailability),
                key: _this.keyCompany,
            };
            _this.galavailServiceEcommer
                .findAvailabilityByCode(_this.requestFindAvailabilityByCode)
                .subscribe(function (response) {
                _this.cruise = response[0];
                _this.cruise.iterIndex = 0;
                //if (localStorage.getItem('gtc-e-commerce-galavail.dataInquire-' + this.keyCompany) === null) {
                var textTempContPromotion = _this.getTextTempContPromotion(_this.type);
                var startDate = _this.cruise.availability[0].startDate.replace(" 12:00:00 AM", "");
                var endDate = _this.cruise.availability[0].endDate.replace(" 12:00:00 AM", "");
                var dataInquire = {
                    empresa: _this.empresa,
                    boat: _this.cruise.name,
                    promotion: _this.getPromotion(_this.cruise.availability[0].charterOnly, _this.cruise.availability[0].promotionLabel, _this.cruise.availability[0].charterPromotionLabel),
                    textTempContPromotion: textTempContPromotion,
                    rackPrice: _this.getCharterPrice(_this.type),
                    promoPrice: _this.getCharterPricePromo(_this.type),
                    startDate: startDate,
                    endDate: endDate,
                    length: _this.cruise.availability[0].length,
                    nameIti: _this.cruise.availability[0].name,
                    passengers: 1,
                    startEndDates: _this.cruise.availability[0].startEndDates,
                    logoBoat: _this.cruise.logo,
                    imageBoat: _this.cruise.image,
                    aditionalServices: _this.cruise.availability[0].aditionalServices,
                    charterOnly: _this.isCharterOnlyOrSearchedCharter(_this.type, _this.cruise.availability[0]),
                    groupsOnly: _this.cruise.availability[0].groupsOnly,
                    primaryColor: _this.colorPrimario,
                };
                _this.galavailServiceEcommer.setLocalStorage("dataInquire-" + _this.keyCompany, dataInquire);
                //}
                _this.storeLocalInquireService.getLocalStorages(_this.keyCompany);
                _this.initForm();
                _this.registerForm.listInterest = _this.getListObjectToForm();
                _this.changeTitlePage();
                switch (_this.storeLocalInquireService.getLength()) {
                    case "8D7N":
                        _this.textDuracion = "8 Days / 7 Nights";
                        break;
                    case "5D4N":
                        _this.textDuracion = "5 Days / 4 Nights";
                        break;
                    case "4D3N":
                        _this.textDuracion = "4 Days / 3 Nights";
                        break;
                }
                var tempItinerary = _this.storeLocalInquireService
                    .getNameIti()
                    .substr(1, 1);
                _this.textDaysCruise = _this.storeLocalInquireService.getLength();
                _this.textItinerary = _this.textDaysCruise;
                _this.textStarEndDay =
                    _this.storeLocalInquireService.getStartEndDates() +
                        " (" +
                        tempItinerary +
                        ")";
                if (_this.storeLocalInquireService.getPromotion().length == 10 ||
                    _this.storeLocalInquireService.getPromotion().length == 0) {
                    _this.textPromo = "none";
                }
                else {
                    _this.textPromo = _this.storeLocalInquireService.getPromotion();
                }
                _this.isLoading = false;
                _this.storeLocalInquireService.setLogoBoat(_this.cruise.logo);
                _this.manageURLMonthYear();
            });
            _this.setScripts();
            _this.setBodyScripts();
            _this.disableChildren = _this.companyService.company.code != 'MTg2' ? false : true;
            _this.whatsappNumber = _this.companyService.getCompanyParams().whatsappNumber;
        }, function (error) {
            // console.log(error.error.date);
            _this.router.navigate(["error/500"]);
        });
        // =============================
        // Load 279391 Sojern Tag v6_js, Pixel Version: 1
        var srcScript = this.renderer2.createElement("script");
        srcScript.type = "text/javascript";
        srcScript.text = "\n      (function () {\n        console.log('>>>>> Load Script 279391');\n        /* Please fill the following values. */\n        var params = {\n          vd1: \"\", /* Departure Date */\n          vd2: \"\", /* Return Date */\n          vf1: \"\", /* Destination City */\n          vs1: \"\", /* Destination State or Region */\n          vn1: \"\", /* Destination Country */\n          vb: \"\", /* Attraction Name */\n          t: \"\" /* Number of Travelers */\n        };\n\n        /* Please do not modify the below code. */\n        var cid = [];\n        var paramsArr = [];\n        var cidParams = [];\n        var pl = document.createElement('script');\n        var defaultParams = {\"vid\":\"tou\",\"et\":\"vcart\"};\n        for(key in defaultParams) { params[key] = defaultParams[key]; };\n        for(key in cidParams) { cid.push(params[cidParams[key]]); };\n        params.cid = cid.join('|');\n        for(key in params) { paramsArr.push(key + '=' + encodeURIComponent(params[key])) };\n        pl.type = 'text/javascript';\n        pl.async = true;\n        pl.src = 'https://beacon.sojern.com/pixel/p/279391?f_v=v6_js&p_v=1&' + paramsArr.join('&');\n        (document.getElementsByTagName('head')[0] ||\n          document.getElementsByTagName('body')[0]).appendChild(pl);\n      })();\n    ";
        this.renderer2.appendChild(this.document.body, srcScript);
        // =============================
    };
    FormComponent.prototype.manageURLMonthYear = function () {
        var startDate = new Date(Date.parse(this.galavailServiceEcommer.getDataofLocalStorage('dataInquire-' + this.keyCompany).startDate));
        var endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
        var companyDateRange = this.companyService.getDateRange();
        this.URLDateRange = companyDateRange.length != 0 ? companyDateRange :
            this.galavailServiceEcommer.getDataofLocalStorage('daterange') ? this.galavailServiceEcommer.getDataofLocalStorage('daterange') :
                this.utilDate.formatDate(startDate) + '-' + this.utilDate.formatDate(endDate);
    };
    ;
    FormComponent.prototype.setBodyScripts = function () {
        this.companyService.getBodyScripts().forEach(function (item) {
            var body = document.createElement("script");
            body.type = "text/javascript";
            body.src = item.srcLinks;
            document.body.appendChild(body);
        });
    };
    FormComponent.prototype.setScripts = function () {
        this.companyService.getScripts().forEach(function (item) {
            var head = document.createElement("script");
            head.type = "text/javascript";
            head.src = item.srcLinks;
            document.head.appendChild(head);
        });
    };
    FormComponent.prototype.cargarValoresPLantilla = function () {
        // console.log('********** CARGA PLANTILLA FORMULARIO');
        // console.log('empresa', this.empresa);
        this.nameLogo = "logo1.png";
        this.nombreEmpresa = this.empresa;
        this.colorPrimario = "#" + this.dataCompany.mainColor;
        this.colorSecundario = "#" + this.dataCompany.secondaryColor;
        this.colorCabecera = "#" + this.dataCompany.headerColor;
        this.colorPie = "#" + this.dataCompany.footerColor;
        // if (this.empresa === 'royal') {
        //   this.nameLogo = 'logo1.png';
        //   this.nombreEmpresa = this.empresa;
        //   this.colorPrimario = '#' + this.dataCompany.mainColor;
        //   this.colorSecundario = '#' + this.dataCompany.secondaryColor;
        //   this.colorCabecera = '#' + this.dataCompany.headerColor;
        //   this.colorPie = '#' + this.dataCompany.footerColor;
        // } else {
        //   this.router.navigate(['error/400']);
        // }
    };
    FormComponent.prototype.enviarFormulario = function (formulario) {
        if (formulario.valid) {
            // this.requestRoyalForm();
            if (this.empresa === "royal") {
                console.log("In Royal");
                this.showSending = true;
                this.showButtonSend = true;
                this.requestRoyalForm();
            }
            else {
                this.prepareSendRequest();
            }
        }
        else {
            console.log("--------------- NO SE PUDO PROCESAR EL FORMULARIO ---------------");
        }
    };
    FormComponent.prototype.generateKeyCompany = function () {
        // const formatedDateToday: string = this.dateToday.getFullYear().toString() + '0' + (this.dateToday.getMonth() + 1) + '0' + this.dateToday.getDate();
        // const encodeDate = window.btoa(formatedDateToday);
        var encodeDate = window.btoa(this.getFormatedDateToday());
        // console.log('encodeDate', encodeDate);
        var encodeCompany = window.btoa(encodeDate + "," + this.empresa);
        // console.log('encodeCompany', encodeCompany);
        this.requestCompany = {
            key: encodeCompany,
        };
        return this.requestCompany;
    };
    FormComponent.prototype.prepareSendRequest = function () {
        var _this = this;
        // console.log('preparate R');
        this.showButtonSend = false;
        this.showSending = true;
        var objectResquest = {
            emailReceptor: this.storeLocalInquireService.getMailCompany(),
            // emailReceptor: 'e-commerce@royalgalapagos.com',
            // emailReceptor: 'edisson@galapagosislands.com',
            subject: "New Request ",
            inquireDTO: {
                // company: this.empresa,
                company: this.dataCompany.name,
                boat: this.storeLocalInquireService.getBoat(),
                promotion: this.textPromo,
                startDate: this.storeLocalInquireService.getStartDate(),
                endDate: this.storeLocalInquireService.getEndDate(),
                days: this.storeLocalInquireService.getLength(),
                opcDays: this.storeLocalInquireService.getNameIti(),
                adults: this.registerForm.formAdultos,
                childs: this.registerForm.formNinos,
                commnets: this.registerForm.formComentarios === ""
                    ? "None specific"
                    : this.registerForm.formComentarios,
                lastName: "",
                firstName: this.registerForm.formContacto,
                email: this.registerForm.formCorreo,
                iti_object: isNullOrUndefined(this.registerForm.formItiObject)
                    ? "Not specific"
                    : this.registerForm.formItiObject,
                phone: isNullOrUndefined(this.registerForm.formItiObject)
                    ? "Not specific"
                    : this.registerForm.formItiObject.nationalNumber,
                country: isNullOrUndefined(this.registerForm.formItiObject)
                    ? "Not specific"
                    : this.getCountry(),
                fullphone: isNullOrUndefined(this.registerForm.formItiObject)
                    ? "Not specific"
                    : this.registerForm.formItiObject.e164Number,
                areacode: isNullOrUndefined(this.registerForm.formItiObject)
                    ? "Not specific"
                    : this.registerForm.formItiObject.dialCode,
                interestPromos: this.registerForm.formOferta,
                agency: this.registerForm.formAgencia === ""
                    ? "Not specific"
                    : this.registerForm.formAgencia,
                reference: this.registerForm.formReferencia === ""
                    ? "Not specific"
                    : this.registerForm.formReferencia,
                charterOnly: this.storeLocalInquireService.getCharterOnly(),
                groupsOnly: this.storeLocalInquireService.getGroupsOnly(),
                ipSender: this.geoIp,
                howFindUs: this.registerForm.howFindUs === ""
                    ? "Not specific"
                    : this.registerForm.howFindUs === "Other"
                        ? this.registerForm.valueOther
                        : this.registerForm.howFindUs,
            },
            company: {
                logoCompany: this.dataCompany.logo,
                nameCompany: this.dataCompany.name,
                mainColorCompany: this.dataCompany.mainColor,
                secondaryColorCompany: this.dataCompany.secondaryColor,
                headerColorCompany: this.dataCompany.headercolor,
                footerColorCompany: this.dataCompany.footerColor,
                infoMailCompany: this.dataCompany.infoEmail,
                phoneCompany: this.dataCompany.phone,
                webSiteCompany: this.dataCompany.webSite,
            },
            listInterest: this.registerForm.listInterest.map(function (item) {
                return {
                    description: item.description,
                    status: item.status ? "Yes" : "No",
                };
            }),
            aditionalServicesList: this.storeLocalInquireService.getAditionalServices().length === 0
                ? ["None specific"]
                : this.storeLocalInquireService.getAditionalServices(),
        };
        this.ngWebflowService.addWebFlowAction(WebFlowAction.INQUIRE_AVAILABILITY_START, {
            data: objectResquest,
        });
        this.galavailServiceEcommer.sendInquireEmail(objectResquest).subscribe(function (res) {
            _this.ngWebflowService.addWebFlowAction(WebFlowAction.INQUIRE_AVAILABILITY_SUCCESS, {
                data: objectResquest
            });
            // console.log(res);
            _this.redirectThanksPage();
        }, function (error) {
            _this.ngWebflowService.addWebFlowAction(WebFlowAction.INQUIRE_AVAILABILITY_FAILED, {
                data: objectResquest
            });
            console.log("DONT SEND");
            console.log(error);
        });
    };
    FormComponent.prototype.redirectThanksPage = function () {
        // console.log('REDIRECCIONA A LA PAGINA DE GRACIAS');
        // this.router.navigate(['/inquire/' + this.empresa + '/' + this.keyCompany + '/thanks']);
        this.router.navigate([
            this.empresa + "/" + this.keyCompany + "/thanks",
            { boat: this.storeLocalInquireService.getBoat(), contact: "inquire" },
        ]);
    };
    FormComponent.prototype.requestRoyalForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.showSending = true;
                this.setFormReservation();
                this.ngWebflowService.addWebFlowAction(WebFlowAction.CRM_INQUIRE_START, this.reservationClass.formReservation);
                this.royalRequestService
                    .requestPost(this.reservationClass.formReservation)
                    .subscribe(function (x) {
                    _this.ngWebflowService.addWebFlowAction(WebFlowAction.CRM_INQUIRE_SUCCESS, tslib_1.__assign({}, x));
                    // console.log(res);
                }, function (err) {
                    _this.ngWebflowService.addWebFlowAction(WebFlowAction.CRM_INQUIRE_FAILED, {
                        json: _this.reservationClass.formReservation,
                        err: err,
                    });
                    _this.prepareSendRequest();
                }, function () {
                    _this.prepareSendRequest();
                });
                return [2 /*return*/];
            });
        });
    };
    FormComponent.prototype.setFormReservation = function () {
        var cruiseIndex = this.cruise.iterIndex;
        var startDate = new Date(this.cruise.availability[cruiseIndex].startDate);
        var endDate = new Date(this.cruise.availability[cruiseIndex].endDate);
        var promoText = this.getPromoName(cruiseIndex) === "0"
            ? "Regular Rate"
            : this.getPromoName(cruiseIndex);
        var newLetter = this.registerForm.formOferta ? "1" : "0";
        this.urlElementsArray = [];
        var urlFinal = environment.pathCRMroyal;
        this.getStringFormDatailRoyal(promoText);
        this.getStringTravelDataRoyal(startDate, endDate);
        this.getInterestDataRoyal();
        this.getContactInfoRoyal();
        this.setUtms();
        this.urlElementsArray.push(newLetter);
        this.reservationClass.formReservation.intnews = newLetter;
        var ip = this.geoIp === "" ? "none" : this.geoIp;
        this.urlElementsArray.push(ip);
        this.reservationClass.formReservation.varip = ip;
        this.pushHowFindUstoArray();
        var urlEscapedElementsArray = this.urlElementsArray.map(function (urlElement) {
            return encodeURIComponent(urlElement);
        });
        this.reservationClass.formReservation.category = this.cruise.category.toString();
        this.reservationClass.formReservation.product = this.cruise.name.toString();
        urlFinal += urlEscapedElementsArray.join("/");
        return urlFinal;
    };
    FormComponent.prototype.pushHowFindUstoArray = function () {
        var howFindUs = this.registerForm.howFindUs === ""
            ? "Not specific"
            : this.registerForm.howFindUs;
        var otherValue = this.registerForm.howFindUs === "Other"
            ? this.registerForm.valueOther
            : "none";
        var deviceStringInfo = this.isMobile();
        this.reservationClass.formReservation.device = deviceStringInfo;
        this.urlElementsArray.push(deviceStringInfo);
        this.reservationClass.formReservation.findus = howFindUs;
        this.urlElementsArray.push(howFindUs);
        this.reservationClass.formReservation.findusother =
            otherValue === "" || otherValue === null ? "none" : otherValue;
        this.urlElementsArray.push(otherValue === "" || otherValue === null ? "none" : otherValue);
        this.reservationClass.formReservation.codeType =
            this.getCodeProcessByCruise();
        this.urlElementsArray.push(this.getCodeProcessByCruise());
    };
    FormComponent.prototype.getCodeProcessByCruise = function () {
        return "RG." + this.cruise.initials + ".AV";
    };
    FormComponent.prototype.isMobile = function () {
        var ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "Tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "Mobile";
        }
        else {
            return "Desktop";
        }
    };
    FormComponent.prototype.setUtms = function () {
        // START SET UTMS
        this.reservationClass.formReservation.utm.utmsource =
            this.getCokieValue("source");
        this.reservationClass.formReservation.utm.utmmedium =
            this.getCokieValue("medium");
        this.reservationClass.formReservation.utm.utmcampaign =
            this.getCokieValue("campaign");
        this.reservationClass.formReservation.utm.utmterm =
            this.getCokieValue("term");
        this.reservationClass.formReservation.utm.utmadg =
            this.getCokieValue("adgroup");
        this.reservationClass.formReservation.utm.utmmtp =
            this.getCokieValue("matchtype");
        this.reservationClass.formReservation.utm.utmcon =
            this.getCokieValue("content");
        this.reservationClass.formReservation.utm.utmad = this.getCokieValue("ad");
        this.reservationClass.formReservation.utm.utmkey =
            this.getCokieValue("keyword");
        this.reservationClass.formReservation.utm.utmext =
            this.getCokieValue("extension");
        this.reservationClass.formReservation.utm.utmplace =
            this.getCokieValue("placement");
        this.reservationClass.formReservation.utm.utmassetid =
            this.getCokieValue("assetid");
        this.reservationClass.formReservation.utm.utmassetgroup =
            this.getCokieValue("assetgroup");
        this.reservationClass.formReservation.utm.utmadtype =
            this.getCokieValue("adtype");
        this.reservationClass.formReservation.utm.urlorigen =
            this.getUrlOrigenCokieValue("url_origen");
        // END SET UTMS
    };
    FormComponent.prototype.getStringFormDatailRoyal = function (promoText) {
        var product = this.royalRequestService.getNameBoatToRoyal(this.storeLocalInquireService.getBoat());
        var resp = "none" + "/" + product + "/" + promoText + "/";
        this.urlElementsArray.push("none");
        this.reservationClass.formReservation.services = "none";
        this.urlElementsArray.push(product);
        this.reservationClass.formReservation.product = product;
        this.urlElementsArray.push(promoText);
        this.reservationClass.formReservation.promotion = promoText;
        // let resp = (services === "" ? "none" : services.substring(0, services.length - 1)) + "/" + product + "/" + promoText + "/";
        return resp;
    };
    FormComponent.prototype.getStringTravelDataRoyal = function (startDate, endDate) {
        var arrivalDate = "";
        var departureDate = "";
        var daysCruise = this.storeLocalInquireService.getLength().substring(0, 1);
        var optionCruise = this.storeLocalInquireService
            .getNameIti()
            .substring(this.storeLocalInquireService.getNameIti().length, 1);
        var numberAdults = this.registerForm.formAdultos;
        var numberChild = this.registerForm.formNinos;
        var comments = this.registerForm.formComentarios === ""
            ? "None specific"
            : this.registerForm.formComentarios;
        var dayString = startDate.getDate() < 10
            ? "0" + String(startDate.getDate())
            : String(startDate.getDate());
        var endDayString = endDate.getDate() < 10
            ? "0" + String(endDate.getDate())
            : String(endDate.getDate());
        arrivalDate = this.monthNames[startDate.getMonth()] + " " + dayString + ", " + startDate.getFullYear();
        departureDate = this.monthNames[endDate.getMonth()] + " " + endDayString + ", " + endDate.getFullYear();
        this.urlElementsArray.push(arrivalDate);
        this.reservationClass.formReservation.traveldate1 = arrivalDate;
        this.urlElementsArray.push(departureDate);
        this.reservationClass.formReservation.traveldate2 = departureDate;
        this.urlElementsArray.push(daysCruise);
        this.reservationClass.formReservation.daycruise = daysCruise;
        this.urlElementsArray.push(optionCruise.trim());
        this.reservationClass.formReservation.opccruise = optionCruise.trim();
        this.urlElementsArray.push(String(numberAdults));
        this.reservationClass.formReservation.numberadult = String(numberAdults);
        this.urlElementsArray.push(String(numberChild));
        this.reservationClass.formReservation.numberchild = String(numberChild);
        this.urlElementsArray.push(comments + "- FROM INQUIRE OF ROYAL");
        this.reservationClass.formReservation.comments = comments + "- FROM INQUIRE OF ROYAL";
        this.urlElementsArray.push("en");
        this.reservationClass.formReservation.languaje = "en";
        return arrivalDate + "/" + departureDate + "/" + daysCruise + "/" + optionCruise + "/" + numberAdults + "/" + numberChild + "/" + comments + "/en/";
    };
    FormComponent.prototype.getCokieValue = function (value) {
        return Cookies.get(value) === undefined || Cookies.get(value) === null
            ? "none"
            : Cookies.get(value);
    };
    FormComponent.prototype.getUrlOrigenCokieValue = function (value) {
        return Cookies.get(value) === undefined || Cookies.get(value) === null
            ? window.location.href
            : Cookies.get(value);
    };
    FormComponent.prototype.getInterestDataRoyal = function () {
        var interestString = "";
        interestString =
            (this.registerForm.listInterest[2].status ? "1" : "0") +
                "/" +
                (this.registerForm.listInterest[0].status ? "1" : "0") +
                "/0/" +
                (this.registerForm.listInterest[1].status ? "1" : "0") +
                "/";
        this.reservationClass.formReservation.intflights = this.registerForm
            .listInterest[2].status
            ? "1"
            : "0";
        this.urlElementsArray.push(this.registerForm.listInterest[2].status ? "1" : "0");
        this.reservationClass.formReservation.intamazon = this.registerForm
            .listInterest[0].status
            ? "1"
            : "0";
        this.urlElementsArray.push(this.registerForm.listInterest[0].status ? "1" : "0");
        this.reservationClass.formReservation.intperu = "0";
        this.urlElementsArray.push("0");
        this.reservationClass.formReservation.intecu = this.registerForm
            .listInterest[1].status
            ? "1"
            : "0";
        this.urlElementsArray.push(this.registerForm.listInterest[1].status ? "1" : "0");
        return interestString;
    };
    FormComponent.prototype.getContactInfoRoyal = function () {
        var _this = this;
        var fName = this.registerForm.formContacto;
        var lName = "none";
        var email = this.registerForm.formCorreo;
        var iti_object = isNullOrUndefined(this.registerForm.formItiObject)
            ? "Not specific"
            : this.registerForm.formItiObject;
        var phone = isNullOrUndefined(this.registerForm.formItiObject)
            ? "Not specific"
            : this.registerForm.formItiObject.nationalNumber;
        var country = isNullOrUndefined(this.registerForm.formItiObject)
            ? "Not specific"
            : this.getCountry();
        var fullphone = isNullOrUndefined(this.registerForm.formItiObject)
            ? "Not specific"
            : this.registerForm.formItiObject.e164Number;
        var areacode = isNullOrUndefined(this.registerForm.formItiObject)
            ? "Not specific"
            : this.registerForm.formItiObject.dialCode;
        var agency = this.registerForm.formAgencia === ""
            ? "Not specific"
            : this.registerForm.formAgencia;
        var reference = this.registerForm.formReferencia === ""
            ? "Not specific"
            : this.registerForm.formReferencia;
        this.urlElementsArray.push(fName);
        this.reservationClass.formReservation.firstname = fName;
        this.urlElementsArray.push(lName);
        this.reservationClass.formReservation.lastname = lName;
        this.urlElementsArray.push(email);
        this.reservationClass.formReservation.email = email;
        this.urlElementsArray.push(phone);
        this.reservationClass.formReservation.itiObject = iti_object;
        this.reservationClass.formReservation.phone = phone;
        this.reservationClass.formReservation.fullphone = fullphone;
        this.reservationClass.formReservation.areaCode = areacode;
        this.urlElementsArray.push(country);
        this.reservationClass.formReservation.country = country;
        this.urlElementsArray.push(agency);
        this.reservationClass.formReservation.agencyname = agency;
        this.urlElementsArray.push(reference);
        this.reservationClass.formReservation.referencename = reference;
        this.cruise.availability[this.cruise.iterIndex].aditionalServices.forEach(function (additionalService) {
            _this.reservationClass.formReservation.additionalServices.push(additionalService.replace("+ ", ""));
        });
        this.reservationClass.formReservation.pricePerPerson = this.cruise.availability[this.cruise.iterIndex].promotionPrice.toString();
        return fName + "/" + lName + "/" + email + "/" + phone + "/" + country + "/" + agency + "/" + reference + "/";
    };
    FormComponent.prototype.getPromoName = function (itineraryIndex) {
        try {
            return (this.promoService.getPromoText(this.cruise.availability[itineraryIndex].promotionType, this.cruise.availability[itineraryIndex].promotionValue) || "");
        }
        catch (error) {
            console.log("ResultsComponent.getPromoName()");
            console.error(error);
            return null;
        }
    };
    FormComponent.prototype.getFormatedDateToday = function () {
        var formatedDateToday;
        var tempMonth = this.dateToday.getMonth() + 1;
        var tempDay = this.dateToday.getDate();
        var formatMonth;
        var formatDay;
        if (tempMonth > 0 && tempMonth < 10) {
            formatMonth = "0" + tempMonth;
        }
        else {
            formatMonth = tempMonth.toString();
        }
        if (tempDay > 0 && tempDay < 10) {
            formatDay = "0" + tempDay;
        }
        else {
            formatDay = tempDay.toString();
        }
        formatedDateToday =
            this.dateToday.getFullYear().toString() + formatMonth + formatDay;
        return formatedDateToday;
    };
    /**
     * Metodo que no ayuda a verificar si el color del pie es claro u oscuro,
     * esto se lo aplica para dar cierto estilos en el div
     * @param hexcolor
     */
    FormComponent.prototype.isTooDark = function (hexcolor) {
        if (hexcolor != null) {
            var r = parseInt(hexcolor.substr(1, 2), 16);
            var g = parseInt(hexcolor.substr(3, 2), 16);
            var b = parseInt(hexcolor.substr(4, 2), 16);
            var yiq = (r * 299 + g * 587 + b * 114) / 1000;
            // Return new color if to dark, else return the original
            // return (yiq < 40) ? '#2980b9' : hexcolor;
            return yiq < 150;
        }
        else {
            return false;
        }
    };
    // *********************************************************
    // *** Metodo para mostrar modal compartir
    /**
     *
     * @param dataBoat
     * @param dataDeparture
     */
    FormComponent.prototype.openDialogShare = function () {
        var currentURL = window.location.href;
        var dialogRef = this.dialog.open(ShareModalComponent, {
            data: {
                dataUrl: currentURL,
            },
        });
        dialogRef.afterClosed().subscribe(function (result) {
            console.log("The dialog was closed");
        });
    };
    // *********************************************************
    FormComponent.prototype.goBack = function () {
        this.router.navigate([
            this.empresa + "/All/All/" + this.URLDateRange + "/1",
        ]);
    };
    FormComponent.prototype.getHeaderTitle = function () {
        return this.isOnHold
            ? "Galapagos Cruise online hold"
            : "Inquire about a Galapagos Cruise";
    };
    FormComponent.prototype.getCountry = function () {
        var _this = this;
        var country;
        this.listCountries.forEach(function (item) {
            if (item.code == _this.registerForm.formItiObject.countryCode) {
                country = item.name;
            }
        });
        return country;
    };
    return FormComponent;
}());
export { FormComponent };
